import { Icons } from '@/components/icons';
import { Button } from '../ui/button';
import { useState } from 'react';
import { WorkflowPresetsModal } from './presets/workflow-presets-modal';

interface EmptyWorkflowsProps {
  readonly disableCreateWorkflows?: boolean;
}

export function EmptyWorkflows({
  disableCreateWorkflows = false,
}: EmptyWorkflowsProps) {
  const [isWorkflowPresetsModalOpen, setIsWorkflowPresetsModalOpen] =
    useState(false);

  return (
    <>
      {isWorkflowPresetsModalOpen && (
        <WorkflowPresetsModal onOpenChange={setIsWorkflowPresetsModalOpen} />
      )}

      <div className='flex h-full flex-col items-center justify-center gap-4 pt-4 pb-6 text-center'>
        <div className='flex flex-col gap-0.5'>
          <span className='font-medium'>Inga arbetsflöden</span>
          <span className='max-w-[400px] text-xs text-muted-foreground'>
            Listor och tabeller kan sparas som arbetsflöden genom att klicka på{' '}
            <Icons.bookmarkAdd className='inline-block size-4' /> uppe till
            höger på sidan du vill spara.
          </span>
        </div>
        {!disableCreateWorkflows && (
          <Button
            type='button'
            className='gap-2'
            onClick={() => setIsWorkflowPresetsModalOpen(true)}
            aria-label='Lägg till från Pigello arbetsflöden'
          >
            <Icons.add className='size-4' /> Lägg till från Pigello arbetsflöden
          </Button>
        )}
      </div>
    </>
  );
}
